export const FastSearchGetters = {}
